/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Palette, Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(theme => ({
  dialogTitle: {
    display: 'flex',
    alignItems: 'center'
  },
  dialogTitleText: {
    flex: 1
  },
  dialogContent: {
    padding: '0 !important'
  },
  dialogActions: {
    padding: `${Tokens.spacing['$sp-4']} !important`
  },
  toolbar: {
    padding: theme.spacing(0, 2)
  },
  manageLocations: {
    padding: theme.spacing(0, 2),
    '& thead th, tbody td': {
      paddingLeft: '0!important',
    },
    '& thead tr th p': {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: 400,
      lineHeight: '16px',
      color: theme.palette.text.secondary,
      marginBottom: '7px',
    },
    '& thead tr th, & tbody tr td': {
      borderBottom: `1px solid ${Palette.colors.grey['200']}!important`
    },
    '& tbody tr:last-child td': {
      borderBottom: `none !important`
    },
    '& tbody .MuiInput-root': {
      width: '100%',
      '& input': {
        padding: '7px 0!important'
      }
    },
  },
  alertMessage: {
    margin: theme.spacing(2, 0)
  },
  autocompleteMultiple: {
    '& .MuiChip-root': {
      background: Palette.colors.cornflower['50'],
      margin: '0 8px 2px 0',
      '& span': {
        color: Palette.colors.darkBlueGrey['900'],
        fontSize: theme.typography.pxToRem(14),
        lineHeight: '20px',
        fontWeight: 400,
      },
      '& svg': {
        color: 'rgba(0, 0, 0, 0.54)!important',
        width: '16px',
        height: '16px',
      },
    },
  },
  locationNoOptions: {
    color: theme.palette.text.secondary,
    padding: theme.spacing(1.75, 1.25)
  },
  locationCheckboxList: {
    maxHeight: '40vh',
    overflow: 'auto'
  },
  locationCheckboxOption: {
    padding: 0
  },
  locationCheckboxPrimaryAction: {
    minWidth: 0
  },
  locationPagination: {
    marginTop: theme.spacing(-1),
    '& > *': {
      boxSizing: 'border-box',
      paddingTop: 0,
      paddingBottom: 0,
      paddingRight: 0
    }
  },
}));
